import { Row, Space } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { GREY_LIGHT } from '../../../styles';
import { BorderColumn, ButtonFullWidth } from '../../../styles/ui';
import MenuItemWrapper from './MenuItemWrapper';

const MenuFooter = () => {
  const { t } = useTranslation();
  return (
    <MenuItemWrapper>
      <Row justify="center">
        <SpaceWithPadding>
          <Link
            to="/privacy"
          >
            <ButtonFullWidth
              type="link"
              disabled
            >
              {t('header.button.privacy')}
            </ButtonFullWidth>
          </Link>
          <BorderColumn
            color={GREY_LIGHT}
          />
          <Link
            to="/terms"
          >
            <ButtonFullWidth
              type="link"
              disabled
            >
              {t('header.button.terms')}
            </ButtonFullWidth>
          </Link>
        </SpaceWithPadding>
      </Row>
    </MenuItemWrapper>
  );
};

export default MenuFooter;

export const SpaceWithPadding = styled(Space)`
   padding: 24px 0;
`;